<template>
    <div class="app">
        <AppHeader/>
        <div class="app-body m-0">
            <!--<Sidebar/>-->
            <main id="main-container" class="container">
                <breadcrumb :list="list"/>
                <gcs-warning v-if="$route.name !== 'Gcs'" />
                <div class="container-fluid mt-5 mt-md-0">
                    <router-view></router-view>
                </div>
            </main>
        </div>

        <AppFooter/>

        <notifications group="form" class="mt-1" style="top: 100px;"/>

        <b-modal
            :title="$t('Caution')"
            v-model="xmlModal"
            hide-footer
            effect="fade/zoom"
            >
            <p v-html="$t('Gent.le Concessionario,<br>è disponibile la nuova versione ATS 8.15.0.')" />
            <p v-html="$t('Tra le novità introdotte, per quanto riguarda l\'interfacciamento di ATS con i cassetti ' +
                'automatici attraverso lo “scambio importo”, a partire da ATS 8.15.0 sarà possibile attivare la funzione, ' +
                'o mantenerla (nel caso il cassetto sia già interfacciato con ATS), acquistando il nuovo modulo ' +
                '“Scambio importo cassetti” da ora disponibile su XDealer.')"/>
        </b-modal>
    </div>
</template>

<script>
//import nav from '../_nav'
import moment from 'moment'
import {Breadcrumb, Footer as AppFooter, Header as AppHeader, Sidebar} from '../components/'
import GcsWarning from "../components/GcsWarning";

export default {
        name: 'full',
        components: {
          GcsWarning,
            AppHeader,
            Sidebar,
            AppFooter,
            Breadcrumb
        },
        data() {

            return {
                xmlModal: false,
               // nav: nav.items
            }
        },
         mounted() {
            const search = new URLSearchParams(window.location.search);
            if(search.get('rel') === 'gcs-confirmed') {

              this.$notify({
                  group: 'form',
                  type: 'success',
                  text: this.$t('Condizioni generali di vendita confermate e attivazione account completata con successo.'),
              });
            }

            //this.xmlModalInit()
        },
        computed: {
            name() {
                return this.$route.name
            },
            list() {
                return this.$route.matched
            }
        },
        methods: {
            xmlModalInit(){
                if (
                    this.$store.getters.getAcls &&
                    this.$store.getters.getAcls.includes("mkt_it") &&
                    this.$store.getters.getDealer
                ){
                    let modalXmlShown = localStorage.getItem('ibAlertShown_'+this.$store.getters.getUser.id)
                    if(modalXmlShown) {
                        if(modalXmlShown !== 'forget' &&
                            !(moment(modalXmlShown).isSame(moment().format('YYYY-MM-DD')))
                        ) {
                            this.showXmlModal()
                        }
                    } else {
                        this.showXmlModal()
                    }
                }
            },
            showXmlModal(){
                localStorage.setItem('ibAlertShown_'+this.$store.getters.getUser.id, moment().format('YYYY-MM-DD'));
                this.xmlModal = true
            },
        }
    }
</script>
